import React, { useEffect, useRef, useState } from "react";
import { useApiQuery } from "@/lib/useApiQuery";
import { toast } from "sonner";
import { useProject } from "@/context/ProjectContext";

/** Polls active alerts every minute and toasts the ones we have not seen yet. */
export function useAlertWatcher() {
  const seenIds = useRef(null); // null until first poll (avoid toasting old alerts on load)
  const { project } = useProject();
  const params = { status: "active", ...(project ? { project } : {}) };
  const { data } = useApiQuery(["activeAlerts", project || null], "/alerts", {
    params,
    refetchInterval: 60000,
    staleTime: 0,
  });
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    if (!data) return;
    setActiveCount(data.length);
    if (seenIds.current === null) {
      seenIds.current = new Set(data.map((a) => a.id));
      return;
    }
    for (const a of data) {
      if (seenIds.current.has(a.id)) continue;
      seenIds.current.add(a.id);
      toast.error(a.label || a.point_dis || "Alert triggered", {
        description: `${a.site_dis ? a.site_dis + " • " : ""}${a.message}`,
        duration: 10000,
      });
    }
  }, [data]);

  return activeCount;
}
